import React, { Component } from 'react';

class Visual extends Component {
  constructor (props) {
    super(props);

    this.state = {
      currentEventInfo: this.props.currentEventInfo
    };
  }

  // -------------------------------------------------------
  // Called when the spin animation has finished by the callback feature of the wheel because I specified callback in the parameters.
  // note the indicated segment is passed in as a parmeter as 99% of the time you will want to know this to inform the user of their prize.
  // -------------------------------------------------------
  alertPrize (indicatedSegment) {
    // 팝업창 열기 : 멈춘 세그먼트의 텍스트(theWheel 에 설정해둔 값) 는 indicatedSegment 로 알 수 있음
    if (indicatedSegment.text === '기프티콘') {
      document.getElementsByClassName('re_popup_w_gifticon')[0].className =
        're_popup_w_gifticon current';
    } else if (indicatedSegment.text === '포인트') {
      document.getElementsByClassName('re_popup_w_point')[0].className =
        're_popup_w_point current';
    } else if (indicatedSegment.text === '꽝') {
      document.getElementsByClassName('re_popup_w_fail')[0].className =
        're_popup_w_fail current';
    }
  }

  // Function with formula to work out stopAngle before spinning animation.
  // Called from Click of the Spin button.

  render () {
    const { bgImgUrlMobile, promotionImgUrlMobile, bgColorCodeMobile, prizeEventTitle } = this.props.currentEventInfo ? this.props.currentEventInfo.eventInfo : {};
    const style = {
      backgroundColor: bgColorCodeMobile
    };

    return (
      <div className='re_visual_w' style={style}>
        <div className='re_visual_inner'>
          <h4 className='hide'>룰렛</h4>
          <img src={bgImgUrlMobile} alt={prizeEventTitle} className='re_visual_image' />
          <div className='re_visual_roulette_w'>
            <img src='//image.sbs.co.kr/event/roulette-event/img/m/roulette_wheel.png' alt='룰렛틀' className='re_visual_roulette_wheel' />
            {/*
            * calculatePrize(segmentNumber) 로 멈출 세그먼트를 스핀 전에 설정할 수 있습니다.
            * 이미 참여한 사람은 re_visual_roulette_button 클릭해도 애니메이션 없이 팝업창 re_popup_w_already 띄워주세요 */}
            <button className='re_visual_roulette_button' onClick={this.props.onCalculatePrize}>
              <span className='re_visual_roulette_button_inner' />
            </button>
            {/**  운영이미지 : 룰렛돌림판 (640x640 사이즈, 아래 스크립트의 loadedImg.src 에 이미지경로가 들어갑니다., 각 세그먼트 구분은 시계방향순서로 segments 배열에 저장하여 사용) */}
            <canvas id='canvas' width='1080' height='1080' className='re_visual_roulette_canvas' />
          </div>
          {/** 운영이미지 : 이달의 상품 (996x264 사이즈) */}
          <h5 className='hide'>이달의 상품</h5>
          <img className='re_visual_image_gift' src={promotionImgUrlMobile} alt='프로모션 이미지' />
        </div>
      </div>
    );
  }
}

export default Visual;
